import { string } from "prop-types";
import React, {useState, useEffect} from "react"

export default function CompanyListItem(props) {
    const [isHovered, setIsHovered] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const itemId = props.company.name + props.company.id.toString()
    return (
        <>
            <div 
                className={"company company-logo" + (isHovered ? " hovered" : "") + (isFocused ? " focused" : "")}
                onClick={() => props.setSelectedCompany(props.company)} 
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {props.company.icon_path 
                    ? <img 
                        className="gap-right-s gap-left-s gap-above-xxs" 
                        src={props.company.icon_path} 
                        alt=""
                        role="presentation" >
                        </img>
                    : <div className="gap-left-s"></div> 
                }
            </div>
            <div 
                id={props.company_name}
                className={"company" + (isHovered ? " hovered" : "") + (isFocused ? " focused" : "")}
                id={itemId}
                onClick={() => props.setSelectedCompany(props.company)} 
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                tabIndex={0}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                role="option"
                onSelect={() => props.setSelectedCompany(props.company)}
            >
                <h3 className={"content1 multiline heavy gap-above-xxs" + (isHovered ? " scale-x scale-y" : "")} >{props.company.name}</h3>
                <h4 className="content2 multiline light gap-below-xxs" >
                    {props.company.industry} &nbsp; | &nbsp; {props.company.city + ", " + props.company.state}
                    {/* { props.company.industry }  &nbsp; | &nbsp; {props.company.city + ", " + props.company.state} */}
                </h4>
            </div>
        </>
    )
}
